
export function updateCustomerDataList(custDataList) {
    return {
      type: 'UPDATE_CustomerDataList',
      custDataList: custDataList
    }
  }